"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const tagStore_1 = require("../../../stores/tag/tagStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'CartHeaderCell',
    props: {
        tableId: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.cartColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", {
                    key: 0,
                    id: `${__props.tableId}-cart-header-cell`,
                    class: "bg-gray-darker px-4 py-2"
                }, null, 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
